export enum PaymentStatusEnum {
  Pending = -1,
  Done = 0,
  Cancelled = 1,
  WrongCredentials = 4,
  NotFound = 7,
  Aborted = 9,
  TerminalBusy = 10,
  CancellationNotFound = 11,
}
